import React from "react";
import { connect } from "react-redux";
import ShortHeaderComponent from "./components/ShortHeaderComponent";
import { Gift } from "lucide-react";
import HyvidRewardsTab from "./components/HyvidRewardsTab";

const HyvidRewards = () => {
  return (
    <div className="flex flex-col gap-6">
      <ShortHeaderComponent
        icon={Gift}
        title={"Hyvid Rewards"}
        description={"Award gift credits and boost engagement across your team"}
      />
      <HyvidRewardsTab/>
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HyvidRewards);
